import React, { useState } from "react";
import { Box } from "@mui/material";

export const getInitials = (name) => {
    if (!name) return "";
    const parts = name.split(" ").filter(Boolean);
    if (parts.length >= 2) {
        return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
};

export const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
        case "todo":
            return "#94a3b8"; // slate
        case "in_progress":
            return "#3b82f6"; // blue
        case "paused":
            return "#f59e0b"; // amber
        case "review":
            return "#8b5cf6"; // purple
        case "done":
            return "#10b981"; // green
        case "blocked":
            return "#ef4444"; // red
        default:
            return "#64748b";
    }
};

const AvatarPill = ({ user, index, zIndexOffset }) => {
    const [isHovered, setIsHovered] = useState(false);

    const color = getStatusColor(user.status);
    const statusText = user.status ? user.status.replace("_", " ") : "Unknown";

    return (
        <Box
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            sx={{
                //mt: "5px",
                mt : 0,
                position: "relative",
                display: "flex",
                alignItems: "center",
                backgroundColor: color,
                borderRadius: "999px",
                //height: 32,
                height:28,
                //minWidth: 40,
                minWidth:36,
                cursor: "pointer",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                zIndex: isHovered ? 100 : zIndexOffset,
                marginLeft: index === 0 ? 0 : "-8px",
                paddingRight: isHovered ? "4px" : "0px",
                width: isHovered ? "auto" : 32,
                boxShadow: "0 0 0 2px #ffffff", // White border to separate overlaps
                ".MuiBox-root &": {
                    // Contextual adjustments if needed
                },
                alignItems: "center",
                justifyContent: "center"
            }}
        >
            <Box
                sx={{
                    width: 28,
                    height: 28,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: 700,
                    fontSize: "0.75rem",
                    flexShrink: 0,
                }}
            >
                {getInitials(user.name)}
            </Box>

            <Box
                sx={{
                    width: isHovered ? "auto" : 0,
                    opacity: isHovered ? 1 : 0,
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    overflow: "hidden",
                    display: "flex",
                }}
            >
                <Box
                    sx={{
                        backgroundColor: "white",
                        color: "black",
                        borderRadius: "999px",
                        padding: "2px 8px",
                        fontSize: "0.7rem",
                        fontWeight: 700,
                        textTransform: "capitalize",
                        whiteSpace: "nowrap",
                    }}
                >
                    {statusText}
                </Box>
            </Box>
        </Box>
    );
};

export const UserAvatarStack = ({ users }) => {
    if (!users || users.length === 0) return null;

    return (
        <Box sx={{ display: "flex", alignItems: "center" }}>
            {users.map((user, index) => (
                <AvatarPill
                    key={user.id}
                    user={user}
                    index={index}
                    zIndexOffset={users.length - index}
                />
            ))}
        </Box>
    );
};
